import { produce } from 'immer';
import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_CONDITIONS_ACTION_TYPE } from '../actions';

const initialState = {
  data: {},
  // SETTLED, not "loaded": true once the fetch is DONE, success or failure. An empty `data` map
  // means both "this loan has no conditions" and "not fetched yet", so a consumer deriving an
  // authoritative status would otherwise read "0 outstanding" as "cleared" before the fetch
  // resolves — and a failed fetch must not leave it waiting forever.
  isSettled: false,
  isGetConditionsPendingStatus: false,
  isAddConditionsPendingStatus: false,
  conditionsWithPendingStatus: [],
};

const loanConditionsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_CONDITIONS_ACTION_TYPE.GET_BROKER_CONDITIONS:
        draft.data = payload || initialState.data;
        draft.isSettled = true;
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.GET_BROKER_CONDITIONS_REJECTED_STATUS:
        draft.isSettled = true;
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.GET_CONDITIONS_BY_LOAN_ID:
        draft.data = payload || initialState.data;
        draft.isGetConditionsPendingStatus = false;
        draft.isSettled = true;
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.GET_CONDITIONS_BY_LOAN_ID_PENDING_STATUS:
        draft.isGetConditionsPendingStatus = true;
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.GET_CONDITIONS_BY_LOAN_ID_REJECTED_STATUS:
        draft.isGetConditionsPendingStatus = false;
        draft.isSettled = true;
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.GET_CONDITIONS_BY_IDS:
        draft.data = { ...draft.data, ...payload };
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.GET_CONDITIONS_BY_IDS_PENDING_STATUS:
        draft.conditionsWithPendingStatus.push(...payload.ids);
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.GET_CONDITIONS_BY_IDS_REJECTED_STATUS:
        draft.conditionsWithPendingStatus = _.without(
          draft.conditionsWithPendingStatus,
          ...payload.ids,
        );
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.GET_CONDITION_BY_CONDITION_ID:
      case LOAN_CONDITIONS_ACTION_TYPE.SIGN_OFF_LOAN_CONDITION:
      case LOAN_CONDITIONS_ACTION_TYPE.UNSIGN_OFF_LOAN_CONDITION:
      case LOAN_CONDITIONS_ACTION_TYPE.REJECT_LOAN_CONDITION:
      case LOAN_CONDITIONS_ACTION_TYPE.UPDATE_LOAN_CONDITION:
      case LOAN_CONDITIONS_ACTION_TYPE.ADD_CONDITION_TASKS:
      case LOAN_CONDITIONS_ACTION_TYPE.LINK_CONDITION_TASKS:
      case LOAN_CONDITIONS_ACTION_TYPE.UNLINK_CONDITION_TASK:
      case LOAN_CONDITIONS_ACTION_TYPE.REMOVE_CONDITION_TASK:
        draft.data[payload.id] = payload;
        draft.conditionsWithPendingStatus = _.without(
          draft.conditionsWithPendingStatus,
          payload.id,
        );
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.DELETE_CONDITION:
        draft.data[payload.id] = {
          ...draft.data[payload.id],
          isDeleted: true,
          lastModified: payload.timestamp,
        };
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.GET_CONDITION_BY_CONDITION_ID_PENDING_STATUS:
      case LOAN_CONDITIONS_ACTION_TYPE.DELETE_CONDITION_PENDING_STATUS:
        draft.conditionsWithPendingStatus.push(payload.id);
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.GET_CONDITION_BY_CONDITION_ID_REJECTED_STATUS:
      case LOAN_CONDITIONS_ACTION_TYPE.DELETE_CONDITION_REJECTED_STATUS:
        draft.conditionsWithPendingStatus = _.without(
          draft.conditionsWithPendingStatus,
          payload.id,
        );
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.ADD_CONDITIONS_PENDING_STATUS:
        draft.isAddConditionsPendingStatus = true;
        break;

      case LOAN_CONDITIONS_ACTION_TYPE.ADD_CONDITIONS:
      case LOAN_CONDITIONS_ACTION_TYPE.ADD_CONDITIONS_REJECTED_STATUS:
        draft.isAddConditionsPendingStatus = false;
        break;

      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default loanConditionsReducer;
